<div id="signature-pad" class="position-relative">
    <canvas #signaturePad class="signature-pad radius-8 mt-4" style="border: solid 1px #E2E2E2;" [width]="dimensions.width" [height]="dimensions.height"></canvas>
    <img style="bottom: 15px; right: 15px;" class="position-absolute" src="assets/images/icons/clear.svg" (click)="clear()" />
</div>